export default {
  computed: {
    windowWidth() {
      return this.$store.state.window.width;
    },
    isLargeScreen() {
      console.log("window resize2", this.windowWidth);
      return this.windowWidth >= 767;
    },

    isMobileScreen() {
      return this.windowWidth < 767;
    },

    isGovApp() {
      return process.env.VUE_APP_API_IS_APP
    },

    isMoTheme() {
      return process.env.VUE_APP_THEME == 'mo'
    },
  },
};
